import { QRCodeSVG } from "qrcode.react";

// Renders a store link as a scannable QR tile (local rendering, no external service).
export default function StoreQr({ value, label, size = 96, className = "", testId }) {
  return (
    <figure data-testid={testId} className={`flex flex-col items-center gap-2 ${className}`}>
      <div className="rounded-xl border border-white/10 bg-white p-2 shadow-[0_0_30px_-10px_rgba(139,92,246,0.5)]">
        <QRCodeSVG value={value} size={size} level="M" bgColor="#ffffff" fgColor="#0b0b0d" marginSize={0} />
      </div>
      <figcaption className="text-[11px] uppercase tracking-[0.18em] text-white/50">{label}</figcaption>
    </figure>
  );
}
